import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [
  // View Inspector Menu
  nativeCommsMessageTypes.SHOW_INSPECTOR_RANGE_TAB,
  nativeCommsMessageTypes.SHOW_INSPECTOR_CONSTRAINTS_TAB,
  nativeCommsMessageTypes.SHOW_INSPECTOR_RELATIONSHIPS_TAB,
  nativeCommsMessageTypes.SHOW_INSPECTOR_PROPERTIES_TAB,
  nativeCommsMessageTypes.SHOW_INSPECTOR_ATTACHMENTS_TAB
];
